<div class="main-header-container">
  <div class="outer" >&nbsp;</div>

  <div>
    <img
      [src]="organizationLogo"
      class="loc-logo"
      aria-label="organization logo"
    />
  </div>
  
  <div class="outer"
  (click)="toggleLanguage()"
  >
  <img width="15px" [src]="'/assets/images/Language_Icon.svg'" />{{ getOtherLanguage()?.text }}
  </div>
</div>
